module.exports = __webpack_public_path__ + "src/assets/games/42/101.jpg";